var exports = {
  "j": "OverlaysTab.module__buttonsWrapper___bXJ0WU",
  "F": "OverlaysTab.module__demoArea___bXJ0WU",
};

module.exports = exports;
